import Vue from "vue";
import * as Sentry from "@sentry/vue";

export default ({ app }) => {
  Sentry.init({
    Vue,
    dsn: process.env.SENTRY_DSN,
    environment: process.env.NODE_ENV,
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(app.router),
      }),
    ],
    tracesSampleRate: 0.01, // Устанавливаем 1% для трассировки
  });

  app.$sentry = Sentry
};
